<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <div class="member-card" [style.height.px]="height">
    <div class="details-container d-flex flex-column h-100 border-disabled rounded">
      <div class="d-flex justify-content-between">
        <!--Name and ID-->
        <div class="card-id text-start">
          <h5 class="mb-1 mb-lg-1 font-size-18 fw-bold card-name text-white" *ngIf="memberDetails$ | async as memberDetails">
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </h5>
          <div class="d-flex mb-0 card-name-info text-white">
            <div>
              {{ memberCard.MemberId }}
            </div>
            <div class="px-1">-</div>
            <div>{{ 'member.card.id' | translate }}</div>
          </div>
        </div>
        <ng-container *ngIf="!isDesktopMenu">
          <div class="card-logo">
            <img [src]="'images/logo.svg' | contentAssetImage" alt="" class="logo" />
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="!isDesktopMenu">
        <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
          <div class="d-flex mb-1 points-container w-100 justify-content-between">
            <div class="points-item">
              <span class="icons material-icons" aria-hidden="true">loyalty</span>
              <div class="points-balance">
                <div class="text-number font-size-18">
                  {{ pointsBalance$ | async | FortressCurrencyPipe: '' : '' : '1.0-0' }}
                </div>
                <div class="text-unit font-size-12">{{ 'member.card.wallet' | translate }}</div>
              </div>
            </div>
            <div class="points-item">
              <span class="icons material-symbols-outlined"> money_bag </span>
              <div class="e-cash-section" *ngIf="ecash$">
                <div class="text-number font-size-18">{{ ecash$ | async | FortressCurrencyPipe }}</div>
                <div class="text-unit font-size-12">{{ 'member.card.ecash.balance' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="w-100">
        <fgb-ecash-button [isMemberCard]="true" [cardRouteURL]="'/payment'"></fgb-ecash-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgb-loading></fgb-loading>
</ng-template>
